import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <h1 className="text-lg font-semibold text-text-primary mb-2">404 — Page Not Found</h1>
      <p className="text-sm text-text-secondary mb-4">The page you are looking for does not exist.</p>
      <Link
        to="/"
        className="text-sm text-baker-red no-underline font-medium hover:underline"
      >
        Return to Dashboard
      </Link>
    </div>
  );
}
